// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-5211b6db3357ebfb.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 8765) return "static/chunks/8765-73b335754a094ef9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3720":"84aa3dce98415a8c","5885":"9315c8aef2abbba1","6866":"878ee6ca0ac4dcba"}[chunkId] + ".js";
};